import { downloadOfflineSalesConversions } from '@/store/api/attribution.api';
import { useAppSelector } from '@/store/hooks';
import { selectOfflineSalesFilters } from '@/store/selectors/attribution/offlineSales.selectors';
import { downloadBlob } from '@/utils/download';
import * as Sentry from '@sentry/react';
import { useState } from 'react';
import { toast } from 'react-toastify';

export const useDownloadOfflineSalesConversions = () => {
  const filters = useAppSelector(selectOfflineSalesFilters);
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async () => {
    if (!filters.advertiserId) return;
    setIsDownloading(true);
    try {
      const { blob, filename } = await downloadOfflineSalesConversions(filters);
      const fallback = `offline-sales-conversions_${filters.dateRangeStart}_${filters.dateRangeEnd}.csv`;
      downloadBlob(blob, filename ?? fallback);
    } catch (error) {
      Sentry.captureException(error, { extra: { filters } });
      toast.error('Failed to download conversions. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};
